// src/pages/MyAssets.jsx
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import TopNavbar from "../../Components/Navbar/Navbar";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Table,
  Spinner,
  Alert,
  Badge,
} from "react-bootstrap";
import "./MyAssets.css";

const API_BASE = "https://api.assetview.warrantyindia.com/api";

const conditionVariant = (c = "") => {
  const v = String(c).toLowerCase();
  if (v === "excellent") return "success";
  if (v === "good") return "primary";
  if (v === "fair") return "warning";
  if (v === "poor" || v === "damaged") return "danger";
  return "secondary";
};

const MyAssets = () => {
  const [user, setUser] = useState({ username: "", Areaoffice: "" });
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [search, setSearch] = useState("");
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("user2");
      if (raw) {
        const u = JSON.parse(raw);
        setUser({
          username: u?.username || "",
          Areaoffice: u?.Areaoffice || "",
        });
      }
    } catch (e) {
      console.error("Failed to parse session user2:", e);
    }
  }, []);

  useEffect(() => {
    if (!user.username) return;
    const run = async () => {
      setPending(true);
      setError("");
      try {
        const resp = await axios.get(`${API_BASE}/assets/mine`, {
          params: { username: user.username, page, limit, search: search.trim() },
        });
        if (resp.data?.ok) {
          setRows(resp.data.data || []);
          setTotal(resp.data.total || 0);
        } else {
          setError(resp.data?.error || "Failed to load data");
        }
      } catch (err) {
        console.error(err);
        setError("Failed to load data");
      } finally {
        setPending(false);
      }
    };
    run();
  }, [user.username, page, limit, search]);

  const totalPages = useMemo(() => Math.max(Math.ceil(total / limit), 1), [total, limit]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const copyId = async (id) => {
    try {
      await navigator.clipboard.writeText(id);
    } catch {}
  };

  return (
    <>
      <TopNavbar />
      <div className="myassets-page">
        <Container fluid className="py-4">
          <Row className="justify-content-center" style={{ width: "100vw",marginTop:"50px" }}>
            <Col xl={10} lg={11} style={{ maxWidth: "100vw" }}>
              <Card className="assets-card shadow-lg border-0">
                <Card.Header className="assets-card-header py-4">
                  <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
                    <div className="d-flex align-items-center gap-3">
                      <div className="header-icon">
                        <i className="fa-solid fa-box-archive"></i>
                      </div>
                      <div>
                        <h1 className="page-title mb-1">My Assets</h1>
                        <p className="page-subtitle mb-0">
                          Username: <strong>{user.username || "-"}</strong> &nbsp;|&nbsp; Area Office:{" "}
                          <strong>{user.Areaoffice || "-"}</strong>
                        </p>
                      </div>
                    </div>

                    <Form className="search-wrap">
                      <i className="fa-solid fa-magnifying-glass search-icon" />
                      <Form.Control
                        className="form-control-professional search-input"
                        placeholder="Search ID / type / condition / year / remarks"
                        value={search}
                        onChange={handleSearchChange}
                      />
                    </Form>
                  </div>
                </Card.Header>

                <Card.Body className="p-0">
                  {error && (
                    <div className="p-3">
                      <Alert variant="danger" className="alert-fade-in mb-3">{error}</Alert>
                    </div>
                  )}

                  {pending ? (
                    <div className="loader-wrap">
                      <Spinner animation="border" />
                      <div className="loader-label">Loading your assets…</div>
                    </div>
                  ) : (
                    <>
                      <div className="table-responsive myassets-table-wrap">
                        <Table hover className="myassets-table mb-0">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Unique No</th>
                              <th>Asset Type</th>
                              <th>Make</th>       
    <th>Model</th> 
                              <th>Qty</th>
                              <th>Condition</th>
                              <th>Receiving Year</th>
                              <th>Assets Value</th>
                              <th>Remarks</th>
                              <th>Created</th>
                            </tr>
                          </thead>
                          <tbody>
                            {rows.length === 0 ? (
                              <tr>
                                <td colSpan={10} className="empty-cell">
                                  <div className="empty-state">
                                    <i className="fa-regular fa-folder-open"></i>
                                    <p>No records found</p>
                                  </div>
                                </td>
                              </tr>
                            ) : (
                              rows.map((r, idx) => (
                                <tr key={r.id}>
                                  <td>{(page - 1) * limit + idx + 1}</td>
                                  <td>
                                    <span className="pill" onClick={() => copyId(r.unique_no)} title="Click to copy">
                                      {r.unique_no}
                                      <i className="fa-regular fa-copy ms-2"></i>
                                    </span>
                                  </td>
                                  <td className="text-capitalize">{r.asset_type}</td>
                                  <td>{r.make || "-"}</td>       
    <td>{r.model || "-"}</td>       
                                  <td>{r.quantity}</td>
                                  <td>
                                    <Badge bg={conditionVariant(r.condition)} pill>
                                      {r.condition || "-"}
                                    </Badge>
                                  </td>
                                  <td>
  {r.receiving_date && !isNaN(new Date(r.receiving_date))
    ? new Date(r.receiving_date).getFullYear()
    : "-"}
</td>
<td className="remarks-cell">{r.asset_value || "-"}</td>
                                  <td className="remarks-cell">{r.remarks || "-"}</td>
                                  <td>{new Date(r.created_at).toLocaleString()}</td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </Table>
                      </div>

                      <div className="table-footer">
                        <div className="text-muted">
                          Showing {(rows.length && (page - 1) * limit + 1) || 0}–
                          {(page - 1) * limit + rows.length} of {total}
                        </div>
                        <div className="pager">
                          <Button
                            variant="outline-secondary"
                            className="btn-nav"
                            disabled={page <= 1}
                            onClick={() => setPage((p) => Math.max(p - 1, 1))}
                          >
                            <i className="fa-solid fa-angle-left me-2"></i>Prev
                          </Button>
                          <span className="page-indicator">
                            Page {page} / {totalPages}
                          </span>
                          <Button
                            variant="outline-secondary"
                            className="btn-nav"
                            disabled={page >= totalPages}
                            onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
                          >
                            Next<i className="fa-solid fa-angle-right ms-2"></i>
                          </Button>
                        </div>
                      </div>
                    </>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default MyAssets;
